/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

// Box Now button styling
document.addEventListener('click', function() {
  setTimeout(function() {
    document.querySelector('#tp-box-now-drawer-lockers-button')
      ?.classList.add('btn', 'btn--primary', 'btn--medium');
    document.querySelector('.tp-drawer-locker-remove-button')
      ?.classList.add('btn', 'btn--solid-border');
  }, 300);
});

document.addEventListener('click', function() {
  setTimeout(function() {
    const boxNowBtn = document.querySelector('#tp-box-now-drawer-lockers-button');
    if (boxNowBtn && !boxNowBtn.querySelector('hover-button')) {
      boxNowBtn.classList.add('btn', 'btn--primary', 'btn--medium');
      boxNowBtn.insertAdjacentHTML('afterbegin', '<hover-button></hover-button>');
    }

    const unselectBtn = document.querySelector('.tp-drawer-locker-remove-button');
    if (unselectBtn && !unselectBtn.querySelector('hover-button')) {
      unselectBtn.classList.add('btn', 'btn--solid-border');
      unselectBtn.insertAdjacentHTML('afterbegin', '<hover-button></hover-button>');
    }
  }, 300);
});


// 13/07/26 mush-emetos addition - allages sto fit-guide wste na douleuei me to drying time
document.addEventListener('DOMContentLoaded', function () {
  if (typeof subscribe !== 'function' || !window.theme?.PUB_SUB_EVENTS?.variantChange) return;

  subscribe(theme.PUB_SUB_EVENTS.variantChange, function (event) {
    const freshDoc = event?.data?.html;
    if (!freshDoc) return;

    const newActiveSpan = freshDoc.querySelector('.guide__line span.is-active');
    const currentSpans = document.querySelectorAll('.guide__line span');
    if (!newActiveSpan || !currentSpans.length) return;

    // Match by position (1st, 2nd, 3rd span, etc.) rather than replacing DOM
    const newSpans = Array.from(freshDoc.querySelectorAll('.guide__line span'));
    const newActiveIndex = newSpans.indexOf(newActiveSpan);

    currentSpans.forEach(function (span, index) {
      span.classList.toggle('is-active', index === newActiveIndex);
    });
  });
});


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
